import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'boards',
    viewPath: props.viewPath,
  })

  let board = useDataValue({
    context: 'board',
    viewPath: props.viewPath,
  })

  let boards = useDataValue({
    context: 'filters',
    path: 'boards',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let shouldRemove = boards.some(({ id }) => id === board.id)
    change([
      ...boards.filter(({ id }) => id !== board.id),
      ...(shouldRemove ? [] : [board]),
    ])
  }
}

export function isChecked(boards, boardId) {
  return boards.some(({ id }) => id === boardId)
}
